import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Dein CSS importieren
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initConsoleRecorder } from './utils/consoleRecorder';

// Initialize in-memory console recorder for error & feedback diagnostics
initConsoleRecorder();

// Unregister any legacy service workers
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const registration of registrations) {
      registration.unregister();
    }
  }).catch((registrationError) => {
    console.error('SW unregistration failed: ', registrationError);
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();